










import { Vue, Component } from 'vue-property-decorator';
import BottomTabbar from '@/components/next/BottomTabbar.vue';
import { isWeiXin } from '@/common/ts/common';
import { getBaseInfo } from './api';

@Component({
  components: {
    BottomTabbar,
  },
})
export default class ViewHolder extends Vue {
  activeTab = 0;
  baseInfo: any = {};
  tabbars = [
    {
      id: 1,
      title: '作品展播',
      path: '/2020-no-waste-city/home',
    },
    {
      id: 2,
      title: '活动介绍',
      path: '/2020-no-waste-city/rule',
    },
    {
      id: 3,
      title: '相关新闻',
      path: '/2020-no-waste-city/news',
    },
    {
      id: 4,
      title: '我要报名',
      path: '/2020-no-waste-city/register',
    },
  ];
  async created() {
    // 处理tabbar高亮
    this.activeTab = this.tabbars.findIndex((item: any) => {
      return item.path === this.$route.path;
    });
    const retBaseInfo = await getBaseInfo();
    this.baseInfo = retBaseInfo.data;
    if (retBaseInfo.data.activityId) {
      this.$addPv(retBaseInfo.data.activityId);
    }
    window.userInfoChange = () => {
      location.reload();
    };
    // 设置pv和分享
    const cover =
      'https://image2.cqcb.com/d/file/topics/activity/2020-08-27/lk1ixzGG-1598513772461.png';
    this.$appShareInfo({
      title: '重庆市“无废城市•绿色生活”短视频大赛作品展播',
      url: location.href,
      subtitle: '作品展播/活动详情/报名参赛/点击进入',
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '重庆市“无废城市•绿色生活”短视频大赛作品展播',
        subtitle: '作品展播/活动详情/报名参赛/点击进入',
        image: cover,
      });
    }
  }
}
